export const userProfilePhotoActionTypes = {
    USER_PROFILE_PHOTO_SET_FETCH_PHOTO_REQUEST_STATE: 'USER_PROFILE_PHOTO_SET_FETCH_PHOTO_REQUEST_STATE',
    USER_PROFILE_PHOTO_SET_USER_PHOTO: 'USER_PROFILE_PHOTO_SET_USER_PHOTO',
    USER_PROFILE_PHOTO_RESET: 'USER_PROFILE_PHOTO_RESET',

    PHOTO_THUMBNAIL_REQUEST_STATE: 'PHOTO_THUMBNAIL_REQUEST_STATE',
    STORE_PHOTO_THUMBNAIL: 'STORE_PHOTO_THUMBNAIL'
};
